export default __webpack_public_path__ + "static/media/marenostrum3.b0721ca6.jpg";